module.exports = __webpack_public_path__ + "img/resource.dd03feed.png";